/* ============================================================
   Caché Perfume · Header global — sticky bar + menú móvil
   Extraído de cache-hero.js para usarse en TODA la web.
   ============================================================ */
(function () {
  'use strict';

  function montarHeader() {
    var bar = document.getElementById('chdr-m-bar');
    var menu = document.getElementById('chdr-m-menu');
    var menuBtn = document.getElementById('chdr-m-menu-btn');

    if (bar) {
      window.addEventListener('scroll', function () {
        bar.classList.toggle('is-stuck', window.scrollY > 12);
      }, { passive: true });
    }

    if (menu && menuBtn) {
      function cerrarMenu() {
        menu.classList.remove('is-open');
        menuBtn.setAttribute('aria-expanded', 'false');
      }
      menuBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !menu.classList.contains('is-open');
        menu.classList.toggle('is-open', open);
        menuBtn.setAttribute('aria-expanded', String(open));
      });
      document.addEventListener('click', function (e) {
        if (!menu.classList.contains('is-open')) return;
        if (e.target instanceof Element && e.target.closest('#chdr-m-menu')) return;
        cerrarMenu();
      });
      // FUN-009: Escape cierra el menú y devuelve el foco al botón (para quien navega con teclado)
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !menu.classList.contains('is-open')) return;
        cerrarMenu();
        menuBtn.focus();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montarHeader);
  } else {
    montarHeader();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.cache-global-header')) montarHeader();
  });
})();
